import { FRAME_COLORS, MATERIAL_TYPES } from '@mixtiles/web-backend-shared'
import { getFrameImage } from './utils'

export const imageNameToConfig: Record<
  string,
  {
    borderImageSlice: string
    color: FRAME_COLORS
    materialType: MATERIAL_TYPES
  }
> = {
  wood: {
    borderImageSlice: '47 44 43 47',
    color: FRAME_COLORS.WOOD,
    materialType: MATERIAL_TYPES.CLASSIC,
  },
  black: {
    borderImageSlice: '47 44 43 47',
    color: FRAME_COLORS.BLACK,
    materialType: MATERIAL_TYPES.CLASSIC,
  },
  white: {
    borderImageSlice: '48 44 43 47',
    color: FRAME_COLORS.WHITE,
    materialType: MATERIAL_TYPES.CLASSIC,
  },
  'wide-red_ash_wood': {
    borderImageSlice: '79 77 78 77',
    color: FRAME_COLORS.RED_ASH_WOOD,
    materialType: MATERIAL_TYPES.WIDE_FRAME,
  },
  'wide-black': {
    borderImageSlice: '111 101 102 108',
    color: FRAME_COLORS.BLACK,
    materialType: MATERIAL_TYPES.WIDE_FRAME,
  },
  'wide-white': {
    borderImageSlice: '80 78 78 81',
    color: FRAME_COLORS.WHITE,
    materialType: MATERIAL_TYPES.WIDE_FRAME,
  },
  frameless: {
    borderImageSlice: '35 35 35 35',
    color: FRAME_COLORS.NONE,
    materialType: MATERIAL_TYPES.FRAMELESS,
  },
}

export const supportedFrameImages: { name: string; url: string }[] =
  Object.entries(imageNameToConfig).map(([name, config]) => {
    return {
      name,
      url: getFrameImage(config.color, config.materialType),
    }
  })
